import httpService from '../services/httpService';
const updateRegisterStep = async (userId, stepSlug) => {
    const data = { slug: stepSlug };
    const response = await httpService.post(`/api/step/update/${userId}`, data);
    return response;
};
export default updateRegisterStep;
